import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit {
  @Input() action: string;
  public showGreenIconAuth = false;
  public showGreenOutlineIconAuth = false;

  public showGreenIconPayment = false;
  public showGreenOutlineIconPayment = false;
  public showGrayIconPayment = true;

  public showGreenOutlineIconConfirmation = false;
  public showGrayIconConfirmation = true;

  public activeTitleStepPayment = false;
  public activeTitleStepConfirmPayment = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    // console.log(this.action);

    if (this.action == 'payment') {
      this.showGreenIconAuth = true;
      this.showGreenOutlineIconPayment = false;

      this.showGreenIconPayment = false;
      this.showGrayIconPayment = false;
      this.showGreenOutlineIconPayment = true;
      this.activeTitleStepPayment = true;
    }
    if (this.action == 'confirmation') {
      this.showGreenIconAuth = true;
      this.showGreenIconPayment = true;
      this.showGrayIconPayment = false;
      this.showGreenOutlineIconPayment = false;

      this.showGrayIconConfirmation = false;
      this.showGreenOutlineIconConfirmation = true;

      this.activeTitleStepPayment = true;
      this.activeTitleStepConfirmPayment = true;
    }
  }

  goToPayment() {
    this.router.navigate([`auth/payment`]);
  }
  goToConfirmation() {
    this.router.navigate([`auth/confirmation-payment`]);
  }
  goToAuth() {
    this.router.navigate([`/pre-payment`]);
  }
}
